import request from '@/utils/request'


// 查询用户积分变动记录列表
export function listLog(query) {
  return request({
    url: '/biz/admin/user/log/list',
    method: 'get',
    params: query
  })
}

// 查询用户积分变动记录分页
export function pageLog(query) {
  return request({
    url: '/biz/admin/user/log/page',
    method: 'get',
    params: query
  })
}

// 查询用户积分变动记录详细
export function getLog(data) {
  return request({
    url: '/biz/admin/user/log/detail',
    method: 'get',
    params: data
  })
}

